import walletApi from './api/index.js'
import walletDefinition from './module/index.js'
import primarySeedIdAtomDefinition from './atoms/primary-seed-id.js'
import seedMetadataAtomDefinition from './atoms/seed-metadata.js'

const DEFAULT_VALID_MNEMONIC_LENGTHS = [12]

const wallet = (
  {
    validMnemonicLengths = DEFAULT_VALID_MNEMONIC_LENGTHS,
    usePassword = true,
    useAutoGeneratedPassword = true,
  } = Object.create(null)
) => {
  return {
    id: 'wallet',
    definitions: [
      {
        definition: walletDefinition,
        config: { validMnemonicLengths, usePassword, useAutoGeneratedPassword },
      },
      { definition: walletApi },
      { definition: primarySeedIdAtomDefinition },
      { definition: seedMetadataAtomDefinition, storage: { namespace: 'wallet' } },
    ],
  }
}

export default wallet
